import { render, staticRenderFns } from "./saleQueryOfVehicleTrajectory.vue?vue&type=template&id=48a8e909&scoped=true"
import script from "./saleQueryOfVehicleTrajectory.vue?vue&type=script&lang=js"
export * from "./saleQueryOfVehicleTrajectory.vue?vue&type=script&lang=js"
import style0 from "./saleQueryOfVehicleTrajectory.vue?vue&type=style&index=0&id=48a8e909&prod&scoped=true&lang=css"
import style1 from "./saleQueryOfVehicleTrajectory.vue?vue&type=style&index=1&id=48a8e909&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a8e909",
  null
  
)

export default component.exports